<template>
    <div>
        <h3>シリーズにまとめる</h3>
        <div>
            <p>
                貸し本棚の作品は「シリーズ」にまとめることができます。
                シリーズにまとめた作品は、シリーズページが設置され、一覧表示ができます。
                この機能は一続きの長編作品シリーズや、短編集の作成に便利です。
            </p>
            <img src="/img/help/novel/34.png" alt="シリーズ" class="img-thumbnail">

            <h4>シリーズを作成する</h4>
            <p>
                マイページのシリーズから、シリーズを新規作成することができます。
                シリーズは公開されている小説作品を追加するまで本棚には表示されません。
            </p>
            <img src="/img/help/novel/35.png" alt="シリーズ追加" class="img-thumbnail">
            <p>
                新規シリーズ追加ボタンからシリーズを追加します。
                シリーズ名は必須です。
            </p>
            <p>
                「<strong>作品を束ねる</strong>」にチェックを入れると、シリーズ作品のうち５作品がスライダーにまとめられます。
                「もっと見る...」をクリックすると、シリーズページに遷移します。
                「作品を束ねる」のチェックを入れない場合、シリーズ作品はすべて本棚に表示され、
                クリックすると目次ページ・本文へ遷移します。<br>
                このチェックは主に短編集などをまとめるために使われます。
            </p>
            <img src="/img/help/novel/37.png" alt="作品をまとめる" class="img-thumbnail">
            <p>
                スライダーにまとめられたシリーズ作品は、ジャンルタブでは該当するジャンルに属する作品しか表示されません。
            </p>

            <h4>シリーズ作品の順番を変更する</h4>
            <p>
                シリーズ作品は、順番を変更することができます。
                これは本棚の作品の順番とは別に保存されます。
                従って、本棚では新しい順に作品をリストし、シリーズページでは時系列順に作品を再リストする、といった並び替えができます。
            </p>
            <img src="/img/help/novel/36.png" alt="順番変更" class="img-thumbnail">
            <p>
                シリーズ作品のリストをドラッグして順番を変更し、
                最後に「順番更新」ボタンをクリックしてください。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "シリーズにまとめる | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>